export default "__VITE_ASSET__386e2c31__"